import { URL_BASE } from "../constants";

export const PaymentProviders = {
  CONEKTA: 0,
  OPENPAY: 1,
  COPY_AND_PAY: 2,
  WEBPAY_PLUS: 3,
  MERCADO_PAGO: 4,
};

export const PaymentMethods = {
  CHECKOUT: "checkout",
};

export const ClientTypes = {
  WEB: 0,
  APP: 1,
};

export const PaymentStatus = {
  PENDING: 0,
  PROCESING: 1,
  PAID: 2,
  REJECTED: 3,
  CANCELLED: 4,
  EXPIRED: 5,
  UNKNOWN: 6,
};

const getToken = function () {
  return localStorage.getItem("tkn");
};

const getResponseData = function (json) {
  if (json && json.data) {
    return json.data;
  }

  if (json && json.Data) {
    return json.Data;
  }

  return json;
};

const getErrorMessage = function (json, defaultMessage) {
  if (json && json.error) {
    return json.error;
  }

  if (json && json.Error) {
    return json.Error;
  }

  if (json && json.message) {
    return json.message;
  }

  if (json && json.Message) {
    return json.Message;
  }

  if (typeof json === "string") {
    return json;
  }

  return defaultMessage;
};

export const createPaymentSession = function (paymentData) {
  return fetch(`${URL_BASE}m/payments/sessions`, {
    method: "post",
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${getToken()}`,
    },
    body: JSON.stringify(paymentData),
  }).then(function (response) {
    return response.json().then(function (json) {
      if (!response.ok) {
        throw getErrorMessage(json, "No se pudo crear la sesión de pago.");
      }

      return getResponseData(json);
    });
  });
};

export const getPaymentStatus = function (paymentSessionId) {
  return fetch(`${URL_BASE}m/payments/sessions/${paymentSessionId}/status`, {
    method: "get",
    headers: {
      Authorization: `Bearer ${getToken()}`,
    },
  }).then(function (response) {
    return response.json().then(function (json) {
      if (!response.ok) {
        throw getErrorMessage(
          json,
          "No se pudo consultar el estatus del pago.",
        );
      }

      return getResponseData(json);
    });
  });
};

export const getPaymentSessionByReference = function (externalReference) {
  return fetch(
    `${URL_BASE}m/payments/sessions/reference/${encodeURIComponent(externalReference)}`,
    {
      method: "get",
      headers: {
        Authorization: `Bearer ${getToken()}`,
      },
    },
  ).then(function (response) {
    return response.json().then(function (json) {
      if (!response.ok) {
        throw getErrorMessage(
          json,
          "No se pudo obtener la sesión de pago por referencia.",
        );
      }

      return getResponseData(json);
    });
  });
};
